<div class="general-settings" [formGroup]="settingsFormGroup" *ngIf="(isLoading$ | async) === false">
  <!-- policy name section -->
  <div class="policy-field">
    <div class="policy-field-text">
      <div class="policy-field-text-title">
        {{ 'policyPage.config.generalSettingsContent.policyName' | labelsProvider }}
      </div>
      <div class="policy-field-text-description" *ngIf="!policyModel.isDefault">
        {{ 'policyPage.config.generalSettingsContent.policyNameDesc' | labelsProvider }}
      </div>
    </div>
    <div class="policy-field-box">
      <input *ngIf="!policyModel.isDefault" formControlName="policyName" type="text" [value]="policyModel.name" />

      <input
        class="policy-field-box-input"
        *ngIf="policyModel.isDefault"
        formControlName="policyName"
        type="text"
        [readonly]="true"
      />
    </div>
  </div>
  <div class="section-divider"></div>
  <!-- policy type section -->
  <div class="policy-field">
    <div class="policy-field-text">
      <div class="policy-field-text-title">
        {{ 'policyPage.config.generalSettingsContent.policyType' | labelsProvider }}
      </div>
    </div>
    <app-select
      *ngIf="!policyModel.isDefault"
      class="policy-field-box"
      placeHolder="Select"
      [options]="policyTypes"
      [selectOptionIndexObservable]="injectCategoryOptionIndex"
      [optionSelected]="policyTypeSelected"
      (optionOnSelection)="onPolicyTypeSelection($event)"
    >
    </app-select>
    <div class="policy-field-box" *ngIf="policyModel.isDefault">
      <input class="policy-field-box-input" formControlName="policyType" type="text" [readonly]="true" />
    </div>
  </div>
  <div class="section-divider"></div>

  <div class="policy-section" *ngIf="policyModel.platform === platformEnum.powerplatform">
    <!-- number of makers section -->
    <div class="policy-field">
      <div class="policy-field-text">
        <div class="policy-field-text-title">
          {{ 'policyPage.config.generalSettingsContent.allowedNumberOfBuilders' | labelsProvider }}
        </div>
        <div class="policy-field-text-description">
          {{ 'policyPage.config.generalSettingsContent.allowedNumberOfBuildersDesc' | labelsProvider }}
        </div>
      </div>
      <div class="policy-field-box">
        <app-numeric-field
          [value]="policyModel.config.allowedNumOfBuilders"
          [editable]="editable"
          formControlName="numberOfBuilders"
        >
        </app-numeric-field>
        <app-effective-policy-settings-button
          class="policy-field-effective-policy-settings-button"
          [platform]="integrationModel.platform"
          [effectivePolicySetting]="EffectivePolicySettingEnum.allowedNumOfBuilders"
        >
        </app-effective-policy-settings-button>
      </div>
    </div>
    <!-- number of high priv users section -->
    <div class="policy-field">
      <div class="policy-field-text">
        <div class="policy-field-text-title">
          {{ 'policyPage.config.generalSettingsContent.highNumberOfPrivilegedUsers' | labelsProvider }}
        </div>
        <div class="policy-field-text-description">
          {{ 'policyPage.config.generalSettingsContent.highNumberOfPrivilegedUsersDesc' | labelsProvider }}
        </div>
      </div>
      <div class="policy-field-box">
        <app-numeric-field
          [value]="policyModel.config.numOfHighPrivilegedUsersInEnvironment"
          [editable]="editable"
          formControlName="highNumberOfPrivilegedUsers"
        >
        </app-numeric-field>
        <app-effective-policy-settings-button
          class="policy-field-effective-policy-settings-button"
          [platform]="integrationModel.platform"
          [effectivePolicySetting]="EffectivePolicySettingEnum.highNumberOfPrivilegedUsers"
        >
        </app-effective-policy-settings-button>
      </div>
    </div>
    <!-- number of critical priv users section -->
    <div class="policy-field">
      <div class="policy-field-text">
        <div class="policy-field-text-title">
          {{ 'policyPage.config.generalSettingsContent.criticalNumberOfPrivilegedUsers' | labelsProvider }}
        </div>
        <div class="policy-field-text-description">
          {{ 'policyPage.config.generalSettingsContent.criticalNumberOfPrivilegedUsersDesc' | labelsProvider }}
        </div>
      </div>
      <div class="policy-field-box">
        <app-numeric-field
          [value]="policyModel.config.numOfCriticalPrivilegedUsersInEnvironment"
          [editable]="editable"
          formControlName="criticalNumberOfPrivilegedUsers"
        >
        </app-numeric-field>
        <app-effective-policy-settings-button
          class="policy-field-effective-policy-settings-button"
          [platform]="integrationModel.platform"
          [effectivePolicySetting]="EffectivePolicySettingEnum.criticalNumberOfPrivilegedUsers"
        >
        </app-effective-policy-settings-button>
      </div>
    </div>
    <app-privileged-identities-agent-section
      [value]="policyModel.config.allowedNumOfPrivilegedIdentitiesToAgent"
      [editable]="editable"
      [platform]="integrationModel.platform"
      [settingsFormGroup]="settingsFormGroup"
    >
    </app-privileged-identities-agent-section>
  </div>

  <div class="section-divider" *ngIf="policyModel.platform === platformEnum.powerplatform"></div>
  @if (policyModel.platform === platformEnum.chatGptEnterprise) {
    <div class="policy-section">
      <app-privileged-identities-gpt-section
        [value]="policyModel.config.allowedNumOfPrivilegedIdentitiesToGpt"
        [editable]="editable"
        [platform]="integrationModel.platform"
        [settingsFormGroup]="settingsFormGroup"
      >
      </app-privileged-identities-gpt-section>
    </div>
    <div class="section-divider"></div>
  }

  <div class="policy-section" *ngIf="policyModel.platform === platformEnum.amazonBedrock">
    <div class="policy-field">
      <div class="policy-field-text">
        <div class="policy-field-text-title">
          {{ 'policyPage.config.generalSettingsContent.allowedMemoryRetentionInDays' | labelsProvider }}
        </div>
        <div class="policy-field-text-description">
          {{ 'policyPage.config.generalSettingsContent.allowedMemoryRetentionInDaysDesc' | labelsProvider }}
        </div>
      </div>
      <div class="policy-field-box">
        <app-numeric-field
          [value]="policyModel.config.allowedMemoryRetentionInDays"
          [editable]="editable"
          formControlName="allowedMemoryRetentionInDays"
          [minValue]="1"
          [maxValue]="365"
        >
        </app-numeric-field>
        <app-effective-policy-settings-button
          class="policy-field-effective-policy-settings-button"
          [platform]="integrationModel.platform"
          [effectivePolicySetting]="EffectivePolicySettingEnum.allowedMemoryRetentionInDays"
        >
        </app-effective-policy-settings-button>
      </div>
    </div>

    <div class="policy-field">
      <div class="policy-field-text">
        <div class="policy-field-text-title">
          {{ 'policyPage.config.generalSettingsContent.allowedMemoryMaxRecentSessions' | labelsProvider }}
        </div>
        <div class="policy-field-text-description">
          {{ 'policyPage.config.generalSettingsContent.allowedMemoryMaxRecentSessionsDesc' | labelsProvider }}
        </div>
      </div>
      <div class="policy-field-box">
        <app-numeric-field
          [value]="policyModel.config.allowedMemoryMaxRecentSessions"
          [editable]="editable"
          formControlName="allowedMemoryMaxRecentSessions"
          [minValue]="1"
        >
        </app-numeric-field>
        <app-effective-policy-settings-button
          class="policy-field-effective-policy-settings-button"
          [platform]="integrationModel.platform"
          [effectivePolicySetting]="EffectivePolicySettingEnum.allowedMemoryMaxRecentSessions"
        >
        </app-effective-policy-settings-button>
      </div>
    </div>
    <div class="section-divider"></div>
  </div>

  <!-- connections section -->
  <div>
    <app-descripted-toggle-section
      *ngIf="!platformsWithoutConnectionsToProdConfiguration.includes(policyModel.platform)"
      titleLabel="policyPage.config.generalSettingsContent.allowedConnectionsToProd"
      description="policyPage.config.generalSettingsContent.allowedConnectionsToProdDesc"
      formControlName="connectionsToProd"
      [value]="policyModel.config.allowConnectionsToProdEnvs"
      [editable]="editable"
    >
      <app-effective-policy-settings-button
        [effectivePolicySetting]="EffectivePolicySettingEnum.allowedConnectionsToProd"
        [platform]="integrationModel.platform"
      >
      </app-effective-policy-settings-button>
    </app-descripted-toggle-section>
  </div>

  <div class="in-section-divider"></div>

  <app-descripted-toggle-section
    *ngIf="!platformsWithoutConnectionsToProdConfiguration.includes(policyModel.platform)"
    titleLabel="policyPage.config.generalSettingsContent.allowedConnectionsToNonProd"
    description="policyPage.config.generalSettingsContent.allowedConnectionsToNonProdDesc"
    formControlName="connectionsToNonProd"
    [value]="policyModel.config.allowConnectionsToNonProdEnvs"
    [editable]="editable"
  >
    <app-effective-policy-settings-button
      [effectivePolicySetting]="EffectivePolicySettingEnum.allowedConnectionsToNonProd"
      [platform]="integrationModel.platform"
    >
    </app-effective-policy-settings-button>
  </app-descripted-toggle-section>

  <div
    class="section-divider"
    *ngIf="
      policyModel.platform === platformEnum.powerplatform ||
      policyModel.platform === platformEnum.budibase ||
      policyModel.platform === platformEnum.airtable
    "
  ></div>

  <!-- trusted identity providers section -->
  <div class="policy-field" *ngIf="policyModel.platform === platformEnum.powerplatform">
    <div class="policy-field-text">
      <div class="policy-field-text-title">
        {{ 'policyPage.config.generalSettingsContent.allowedIdentityProviders' | labelsProvider }}
      </div>
      <div class="policy-field-text-description">
        {{ 'policyPage.config.generalSettingsContent.allowedIdentityProvidersDesc' | labelsProvider }}
      </div>
    </div>
    <div class="multi-select-and-button">
      <app-multi-select
        class="policy-field-box"
        [options$]="identityProvidersOptions$"
        (optionOnSelection)="onIdentityProvidersSelection($event)"
        [selectedIds]="identityProvidersSelected"
        [placeHolder]="'policyPage.config.generalSettingsContent.allowedIdentityProvidersPlaceholder' | labelsProvider"
      >
      </app-multi-select>
      <div class="multi-select-and-button-spacer"></div>
      <app-effective-policy-settings-button
        class="multi-select-policy-field-effective-policy-settings-button"
        [platform]="integrationModel.platform"
        [effectivePolicySetting]="EffectivePolicySettingEnum.allowedIdentityProviders"
      >
      </app-effective-policy-settings-button>
    </div>
  </div>
  <div class="policy-section" *ngIf="policyModel.platform === platformEnum.powerBI">
    <!-- allowed num of privileged identities in workspace section -->
    <div class="policy-field">
      <div class="policy-field-text">
        <div class="policy-field-text-title">
          {{ 'policyPage.config.generalSettingsContent.allowedNumOfPrivilegedIdentitiesInWorkspace' | labelsProvider }}
        </div>
        <div class="policy-field-text-description">
          {{
            'policyPage.config.generalSettingsContent.allowedNumOfPrivilegedIdentitiesInWorkspaceDesc' | labelsProvider
          }}
        </div>
      </div>
      <div class="policy-field-box">
        <app-numeric-field
          [value]="policyModel.config.allowedNumOfPrivilegedIdentitiesInWorkspace"
          [editable]="editable"
          formControlName="allowedNumOfPrivilegedIdentitiesInWorkspace"
        >
        </app-numeric-field>
        <app-effective-policy-settings-button
          class="policy-field-effective-policy-settings-button"
          [platform]="integrationModel.platform"
          [effectivePolicySetting]="EffectivePolicySettingEnum.allowedNumOfPrivilegedIdentitiesInWorkspace"
        >
        </app-effective-policy-settings-button>
      </div>
    </div>

    <!-- allowed num of privileged identities to dashboard section -->
    <div class="policy-field">
      <div class="policy-field-text">
        <div class="policy-field-text-title">
          {{ 'policyPage.config.generalSettingsContent.allowedNumOfPrivilegedIdentitiesToDashboard' | labelsProvider }}
        </div>
        <div class="policy-field-text-description">
          {{
            'policyPage.config.generalSettingsContent.allowedNumOfPrivilegedIdentitiesToDashboardDesc' | labelsProvider
          }}
        </div>
      </div>
      <div class="policy-field-box">
        <app-numeric-field
          [value]="policyModel.config.allowedNumOfPrivilegedIdentitiesToDashboard"
          [editable]="editable"
          formControlName="allowedNumOfPrivilegedIdentitiesToDashboard"
        >
        </app-numeric-field>
        <app-effective-policy-settings-button
          class="policy-field-effective-policy-settings-button"
          [platform]="integrationModel.platform"
          [effectivePolicySetting]="EffectivePolicySettingEnum.allowedNumOfPrivilegedIdentitiesToDashboard"
        >
        </app-effective-policy-settings-button>
      </div>
    </div>

    <!-- allowed num of privileged identities to dataset section -->
    <div class="policy-field">
      <div class="policy-field-text">
        <div class="policy-field-text-title">
          {{ 'policyPage.config.generalSettingsContent.allowedNumOfPrivilegedIdentitiesToDataset' | labelsProvider }}
        </div>
        <div class="policy-field-text-description">
          {{
            'policyPage.config.generalSettingsContent.allowedNumOfPrivilegedIdentitiesToDatasetDesc' | labelsProvider
          }}
        </div>
      </div>
      <div class="policy-field-box">
        <app-numeric-field
          [value]="policyModel.config.allowedNumOfPrivilegedIdentitiesToDataset"
          [editable]="editable"
          formControlName="allowedNumOfPrivilegedIdentitiesToDataset"
        >
        </app-numeric-field>
        <app-effective-policy-settings-button
          class="policy-field-effective-policy-settings-button"
          [platform]="integrationModel.platform"
          [effectivePolicySetting]="EffectivePolicySettingEnum.allowedNumOfPrivilegedIdentitiesToDataset"
        >
        </app-effective-policy-settings-button>
      </div>
    </div>

    <!-- allowed num of privileged identities to report section -->
    <div class="policy-field">
      <div class="policy-field-text">
        <div class="policy-field-text-title">
          {{ 'policyPage.config.generalSettingsContent.allowedNumOfPrivilegedIdentitiesToReport' | labelsProvider }}
        </div>
        <div class="policy-field-text-description">
          {{ 'policyPage.config.generalSettingsContent.allowedNumOfPrivilegedIdentitiesToReportDesc' | labelsProvider }}
        </div>
      </div>
      <div class="policy-field-box">
        <app-numeric-field
          [value]="policyModel.config.allowedNumOfPrivilegedIdentitiesToReport"
          [editable]="editable"
          formControlName="allowedNumOfPrivilegedIdentitiesToReport"
        >
        </app-numeric-field>
        <app-effective-policy-settings-button
          class="policy-field-effective-policy-settings-button"
          [platform]="integrationModel.platform"
          [effectivePolicySetting]="EffectivePolicySettingEnum.allowedNumOfPrivilegedIdentitiesToReport"
        >
        </app-effective-policy-settings-button>
      </div>
    </div>
    <app-privileged-identities-ai-skill-section
      [value]="policyModel.config.allowedNumOfPrivilegedIdentitiesToAiSkill"
      [editable]="editable"
      [platform]="integrationModel.platform"
      [settingsFormGroup]="settingsFormGroup"
    >
    </app-privileged-identities-ai-skill-section>
  </div>

  <!-- Budibase settings -->
  <div class="policy-section" *ngIf="policyModel.platform === platformEnum.budibase">
    <div class="policy-field">
      <div class="policy-field-text">
        <div class="policy-field-text-title">
          {{ 'policyPage.config.generalSettingsContent.allowedNumOfPrivilegedIdentitiesInWorkspace' | labelsProvider }}
        </div>
        <div class="policy-field-text-description">
          {{
            'policyPage.config.generalSettingsContent.allowedNumOfPrivilegedIdentitiesInWorkspaceDesc' | labelsProvider
          }}
        </div>
      </div>
      <div class="policy-field-box">
        <app-numeric-field
          [value]="policyModel.config.allowedNumOfPrivilegedIdentitiesInWorkspace"
          [editable]="editable"
          formControlName="allowedNumOfPrivilegedIdentitiesInWorkspace"
        >
        </app-numeric-field>
        <app-effective-policy-settings-button
          class="policy-field-effective-policy-settings-button"
          [platform]="integrationModel.platform"
          [effectivePolicySetting]="EffectivePolicySettingEnum.allowedNumOfPrivilegedIdentitiesInWorkspace"
        >
        </app-effective-policy-settings-button>
      </div>
    </div>
  </div>

  <div class="section-divider" *ngIf="policyModel.platform === platformEnum.budibase"></div>

  <!-- Airtable settings -->
  <div class="policy-section" *ngIf="policyModel.platform === platformEnum.airtable">
    <div class="policy-field">
      <div class="policy-field-text">
        <div class="policy-field-text-title">
          {{ 'policyPage.config.generalSettingsContent.allowedNumOfPrivilegedIdentitiesToTable' | labelsProvider }}
        </div>
        <div class="policy-field-text-description">
          {{ 'policyPage.config.generalSettingsContent.allowedNumOfPrivilegedIdentitiesToTableDesc' | labelsProvider }}
        </div>
      </div>
      <div class="policy-field-box">
        <app-numeric-field
          [value]="policyModel.config.allowedNumOfPrivilegedIdentitiesToTable"
          [editable]="editable"
          formControlName="allowedNumOfPrivilegedIdentitiesToTable"
        >
        </app-numeric-field>
        <app-effective-policy-settings-button
          class="policy-field-effective-policy-settings-button"
          [platform]="integrationModel.platform"
          [effectivePolicySetting]="EffectivePolicySettingEnum.allowedNumOfPrivilegedIdentitiesToTable"
        >
        </app-effective-policy-settings-button>
      </div>
    </div>
  </div>

  <div class="section-divider" *ngIf="policyModel.platform === platformEnum.airtable"></div>

  <app-form-footer
    *ngIf="editable"
    [changesWereDone]="changesWereDone"
    (resetChanges)="resetForm()"
    (saveChanges)="updatePolicyConfig()"
    (cancelSettings)="cancelSettings()"
  ></app-form-footer>
</div>

<div *ngIf="isLoading$ | async" class="general-settings-spinner">
  <mat-progress-spinner color="primary" mode="indeterminate"> </mat-progress-spinner>
</div>
